import { message } from "antd";
import { Service } from "app/config/service";
import API_ROUTES from "app/constants/routes/api";
import { getItem } from "app/utils/session";
import get from "lodash/get";
import { cachingScannerData } from "../caching/action";
import { setActionItem, setNotificationMessage, setFiscalYear } from '../home/action';
import { setIntervalId } from "../reports/action";
import {
  gettingAllJobs,
  getAllJobsError,
  setAllJobs,
  updateJobSuccess,
  AddJobEvidence1,
  getJobEvidenceMiddleware,
  apiLoader,
  AddJobEvidenceError,
  AddJobEvidenceSuccess,
  setActiveRentArrange,
  getJobId,
  getSingleJobDetails,
  setSingleJobDetails,
  getUpdateApiData,
  setQrSearchCylinderValidation,
  setQRSearchCylinder,
  setSearchUserData,
  setReviews,
  searchMyJobsData,
  loaderFlag,
  getActiveRentArrange,
  setUpdateHistory,
  setQrResultData,
  setJobReadable,
  setConfirmationJobReport,
  setPopUpMessageData,
  setFiscalYearList,
  jobDetail,
  setQuickLinksData,
} from "./action";

import {
  RECYCLE_JOB_CREATE,
  GET_ALL_JOBS,
  UPDATE_JOB,
  ADD_EVIDENCE_JOB,
  GET_EVIDENCE_JOB,
  GET_ACTIVE_RENT_ARRANGE,
  CREATE_JOB,
  CREATE_RECOVERY_AND_FILL_JOB,
  FILL_RECOVERY_JOB_CREATE,
  GET_SINGLE_JOB,
  DELETE_CYLINDER_EQUIPMENT,
  EDIT_RENTAL_JOB,
  ADD_RECYCLE_JOB,
  ADD_COMPLETE_RECYCLE_JOB,
  GET_QR_CYLINDER_DATA,
  QR_SEARCH_CYLINDER_VALIDATION,
  UPDATE_AWAITING_DATA,
  UPDATE_PROCESS_CERTIFICATE,
  SEARCH_USER,
  BUILDING_USER_SEARCH,
  UPDATE_PROCESS_JOB,
  ADD_REVIEW,
  GET_REVIEW,
  UPDATE_REFRIGERANT_VOLUME,
  UPDATE_JOB_COMPLETE,
  SEARCH_MY_JOBS,
  SHARE_CERTIFICATE,
  JOB_REVERT,
  UPDATE_HISTORY,
  SET_JOB_READ,
  GET_CONFIRMATION_REPORT,
  SEARCH_QR_JOBS,
  FISCAL_YEAR_LIST,
  UPDATE_RENT_RETURN
} from "./types";
import invalidScanner from "assets/images/InvalidScanner.png";
import { setApiLoader, setChildAssociateContractor, setSearchNonAssociateUsers } from "../admin/action";
import { include, length } from "app/utils/javascript";
import { cylinderListSorting } from "app/common/components/customFunction";

const { createLogic } = require("redux-logic");

const getAllJobsLogic = createLogic({
  type: GET_ALL_JOBS,
  latest: true,
  process({ action }, dispatch, done) {
    dispatch(gettingAllJobs());
    const { page, type } = action.payload;
    const authToken = getItem("token");
    const payload = { authToken: authToken ? authToken : "", type };
    // axios.post(API_ROUTES.GET_ALL_USERS(action.payload), payload, {
    //     // headers: { "Content-Type": "multipart/form-data" },
    // });
    dispatch(loaderFlag(true))
    Service({
      method: "post",
      url: API_ROUTES.GET_ALL_JOBS(page),
      data: { ...payload },
    })
      .then((res) => {
        const allAdminData = get(res, "data.data", {});
        dispatch(loaderFlag(false))
        dispatch(
          setAllJobs({
            ...allAdminData,
            requestedPage: page,
          })
        );
        done();
      })
      .catch((err) => {
        dispatch(loaderFlag(false))
        dispatch(getAllJobsError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const updateJobLogic = createLogic({
  type: UPDATE_JOB,
  latest: true,
  process({ action }, dispatch, done) {
    // dispatch(gettingAllJobs());
    // const { page, type } = action.payload;
    dispatch(loaderFlag(true))
    const authToken = getItem("token");
    const payload = {
      authToken: authToken ? authToken : "",
      ...action.payload,
    };
    // axios.post(API_ROUTES.GET_ALL_USERS(action.payload), payload, {
    //     // headers: { "Content-Type": "multipart/form-data" },
    // });

    Service({
      method: "post",
      url: API_ROUTES.UPDATE_JOB,
      data: { ...payload },
    })
      .then((res) => {
        dispatch(setNotificationMessage({ type: "success", message: "JobUpdatedSuccessfully" }))
        dispatch(updateJobSuccess({ ...payload }));
        dispatch(loaderFlag(false))
        done();
      })
      .catch((err) => {
        // dispatch(getAllJobsError(err));
        dispatch(loaderFlag(false))
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const dynamicPayload = (data) => {
  switch (data.payload.typeName) {
    case "note":
      return `note`;
    case "video":
      return `video`;
    case "image":
      return `image`;
    case "audio":
      return `audio`;
    default:
      break;
  }
};

const AddJobEvidences = createLogic({
  type: ADD_EVIDENCE_JOB,
  latest: true,
  process({ action }, dispatch, done) {
    dispatch(apiLoader(true));
    dispatch(AddJobEvidence1());
    const authToken = getItem("token");
    const typeOfDataName = dynamicPayload(action);
    let formData = new FormData();
    formData.append("authToken", authToken ? authToken : "");
    formData.append("jobId", action.payload.jobId);
    formData.append(`${typeOfDataName}`, action.payload.value);

    Service({
      method: "post",
      url: API_ROUTES.ADD_JOB_EVIDENCE,
      data: formData,
    })
      .then((res) => {
        if (res.data?.data === null) {
          dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }))
          dispatch(AddJobEvidenceError());
        } else {
          if (action.payload) dispatch(AddJobEvidence1(res));
          dispatch(AddJobEvidenceSuccess(true));
        }
        dispatch(apiLoader(false));
        done();
      })
      .catch((err) => {
        dispatch(apiLoader(false));
        dispatch(AddJobEvidenceError());
        // dispatch(getAllJobsError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const getJobEvidence = createLogic({
  type: GET_EVIDENCE_JOB,
  latest: true,
  process({ action }, dispatch, done) {
    dispatch(getJobEvidenceMiddleware());
    const authToken = getItem("token");
    const payload = {
      authToken: authToken ? authToken : "",
      jobId: action.payload || "",
    };

    Service({
      method: "post",
      url: API_ROUTES.GET_JOB_EVIDENCE,
      data: { ...payload },
    })
      .then((res) => {
        // message.success("Get Job Evidence successfully!");
        const info = res && res.data.data;
        if (action.payload) dispatch(getJobEvidenceMiddleware(info));
        done();
      })
      .catch((err) => {
        // dispatch(getAllJobsError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const getAllRentArrange = createLogic({
  type: GET_ACTIVE_RENT_ARRANGE,
  latest: true,
  process({ action, getState }, dispatch, done) {
    const authToken = getItem("token");
    const payload = { authToken, ...action?.payload?.payload };
    delete payload.cursor;
    delete payload.pageNo;
    const queryKey = JSON.stringify(Object.keys(payload).sort().map(key => [key, payload[key]]));
    const previous = getState().jobs.jobTypeDetail;
    const requestedPage = action?.payload?.pageNo || 1;
    const sameQuery = previous.cursorQueryKey === queryKey;
    const pageCursors = sameQuery && requestedPage > 1 ? previous.pageCursors || {} : {};
    // Page numbers are local UI state only; the API receives an opaque cursor.
    const cursor = requestedPage > 1 && sameQuery ? pageCursors[requestedPage] : undefined;
    const currentPage = cursor != null && cursor !== "" ? requestedPage : 1;
    if (currentPage > 1) {
      payload.cursor = cursor;
    }
    dispatch(loaderFlag(true))
    Service({
      method: "post",
      url: API_ROUTES.RENT_ARRANGE,
      data: payload,
    })
      .then((res) => {
        const allRentArrangeData = get(res, "data.data", {});
        dispatch(loaderFlag(false))
        dispatch(
          setActiveRentArrange({
            ...allRentArrangeData,
            requestedPage: action.payload,
            currentPage,
            cursorQueryKey: queryKey,
            pageCursors: {
              ...Object.fromEntries(Object.entries(pageCursors).filter(([page]) => Number(page) <= currentPage)),
              ...(allRentArrangeData.nextCursor != null && allRentArrangeData.nextCursor !== ""
                ? { [currentPage + 1]: allRentArrangeData.nextCursor }
                : {}),
            },
          })
        );

        done();
      })
      .catch((err) => {
        dispatch(loaderFlag(false))
        //dispatch(getAllCustomersError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const createJobLogic = createLogic({
  type: CREATE_JOB,
  latest: true,
  process({ action }, dispatch, done) {

    Service({
      method: "post",
      url: API_ROUTES.CREATE_JOB_API,
      data: action.payload,
    })
      .then((res) => {
        if (res?.data?.data) {
          message.success(action?.msg);
          dispatch(setActionItem("JOB_VIEW", "VIEW"));

        }
      })
      .catch((err) => {
        //dispatch(getAllCustomersError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));

      });
  },
});

const createRecoveryAndFillJobLogic = createLogic({
  type: CREATE_RECOVERY_AND_FILL_JOB,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    let payload;
    if (
      action.payload.jobType === "RECOVERY" ||
      action.payload.jobType === "FILL"
    ) {
      payload = {
        authToken: authToken ? authToken : "",
        contractorId: action.payload.contractorId,
        category: action.payload.category,
        managementNumber: action.payload.managementNumber,
        jobCompletionDate: action.payload.jobCompletionDate,

        subcategory: action.payload.subcategory,
        jobType: action.payload.jobType,
        // dealerId: action.payload.dealerId || null,
        // dealerTwoId: action.payload.dealerTwoId || null,
        additionalDealer: action.payload.additionalDealer || null,
        customerId: action.payload.customerId,
        buildingId: action?.payload?.buildingId || "",
        recovery: action.payload.recovery,
        fillAirConditioningEquipments: action.payload.fillAirConditioningEquipments || [],
        fillRefrigeratorEquipments: action.payload.fillRefrigeratorEquipments || [],
        recoveryAirConditioningEquipments: action.payload.recoveryAirConditioningEquipments || [],
        recoveryRefrigeratorEquipments: action.payload.recoveryRefrigeratorEquipments || [],
        recoveryCarAirConditioningEquipments: action.payload.recoveryCarAirConditioningEquipments || [],
        fillCarAirConditioningEquipments: action.payload.fillCarAirConditioningEquipments || [],
        jobId: action.payload.jobId,
        processType: action.payload.processType,
        process: action.payload.process,
      };
      if (action.payload?.customerBusinessName) { payload.customerBusinessName = action.payload?.customerBusinessName }
      if (action.payload?.buildingName) { payload.buildingName = action.payload?.buildingName }
      if (action.payload?.recycleFactoryId) { payload.recycleFactoryId = action.payload?.recycleFactoryId }
    }
    if (action.payload.jobType === "RENT") {
      payload = {
        authToken: authToken ? authToken : "",
        lenderId: action.payload.senderId,
        borrowerId: action.payload.receiverId,
        cylinderCount: action.payload.selectedRequiredCount,
        category: 1,
        subcategory: 2,
        arrivalDate: action.payload.selectedDate,
        cylinder: action.payload.cylinderId,
        jobType: action.payload.jobType,
        jobSubType: action.payload.jobSubType,
        transporterId: action?.payload?.transporterId,
      };
    }

    Service({
      method: "post",
      url: API_ROUTES.UPDATE_CYLINDER_JOB,
      data: payload,
    })
      .then((res) => {
        if (res?.data?.data?.success) {
          if (
            action.payload.jobType === "RECOVERY" ||
            action.payload.jobType === "FILL"
          ) {
            message.success(`${action?.msg} ${action?.payload?.id}`)
          } else {
            message.success(action?.msg);
          }
          dispatch(setActionItem("JOB_VIEW", "VIEW"));
        }
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const getSingleJobData = createLogic({
  type: GET_SINGLE_JOB,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = { authToken, jobId: action?.payload?.jobId }
    dispatch(loaderFlag(true));
    Service({
      method: "post",
      url: API_ROUTES.GET_SINGLE_JOB_API,
      data: payload,
    })
      .then((res) => {
        if (res?.data?.data) {
          const data = res?.data?.data
          if (include(["SE_RECYCLE_COMPLETE", "SE_PROCESS_COMPLETED", "SE_DISPOSE_COMPLETE", "PROCESS_COMPLETED", "RECYCLE_COMPLETE", "DISPOSE_COMPLETE"], data?.status)) {
            const dataList = { ...data, recycleDisposeCylinderInfo: length(data?.recycleDisposeCylinderInfo) ? cylinderListSorting(data?.recycleDisposeCylinderInfo) : [] }
            dispatch(setSingleJobDetails(dataList || {}));
        } else{
          dispatch(setSingleJobDetails(res?.data?.data || {}));
        }
          dispatch(getJobId(res?.data?.data?.jobId));
          if (action?.payload?.id) {
            dispatch(setJobReadable({ data: action?.payload }));
          }
        }
        dispatch(loaderFlag(false));
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(loaderFlag(false));
        done();
      });
  },
});

const setJobReadData = createLogic({
  type: SET_JOB_READ,
  latest: true,
  process({ action, getState }, dispatch, done) {
    const authToken = getItem("token");
    const { id, read, pageNo } = action?.payload?.data;
    const payload = { authToken, id, read };
    Service({
      method: "patch",
      url: API_ROUTES.GET_SINGLE_JOB_API,
      data: payload,
    })
      .then((res) => {
        if (pageNo) {
          const { status, tab } = action?.payload?.data?.jobDetail;
          const getHomeState = (state) => state?.home?.fiscalYear;
          const fiscalYear = getHomeState(getState());
          dispatch(getActiveRentArrange({ pageNo, payload: { status, type: tab, fiscalYear } }));
        }
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});


const fillRecoveryJobCreateLogic = createLogic({
  type: FILL_RECOVERY_JOB_CREATE,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = {
      authToken: authToken ? authToken : "",
      jobType: action.payload.jobType,
    };

    Service({
      method: "POST",
      url: API_ROUTES.CREATE_JOB_API,
      data: payload,
    })
      .then((res) => {
        if (res.data.data.success === true) {
          dispatch(getJobId(res.data.data.jobId));
          message.success(`${action.payload.msg}`)
        }
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const deleteCylinderLogic = createLogic({
  type: DELETE_CYLINDER_EQUIPMENT,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    let payload = action.payload
    payload.authToken = authToken ? authToken : ""

    dispatch(apiLoader(true))

    Service({
      method: "DELETE",
      url: API_ROUTES.UPDATE_CYLINDER_JOB,
      data: payload,
    })
      .then((res) => {
        if (res.data.data.success === true) {
          dispatch(getUpdateApiData(res.data.data))
        }
        message.success(action?.msg);
        dispatch(apiLoader(false))
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(apiLoader(false))
        done();
      });
  },
});

const editRentalJobLogic = createLogic({
  type: EDIT_RENTAL_JOB,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    let payload = action.payload;
    payload.authToken = authToken ? authToken : "";

    Service({
      method: "post",
      url: API_ROUTES.UPDATE_CYLINDER_JOB,
      data: payload,
    })
      .then((res) => {
        if (res.data.data.success === true) {
          dispatch(setActionItem("JOB_VIEW", "VIEW"))
        }
        message.success(action?.msg);
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const addNewRecycleJob = createLogic({
  type: ADD_RECYCLE_JOB,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    let payload = action.payload;
    payload.authToken = authToken
    Service({
      method: "post",
      url: API_ROUTES.ADD_NEW_CYLINDER,
      data: payload,
    })
      .then((res) => {
        message.success(action.msg);
        dispatch(setActionItem("JOB_VIEW", "VIEW"))
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});


const addCompletedRecycleJob = createLogic({
  type: ADD_COMPLETE_RECYCLE_JOB,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    let payload = action.payload;
    payload.authToken = authToken
    Service({
      method: "post",
      url: API_ROUTES.ADD_COMPLETE_CYLINDER,
      data: payload,
    })
      .then((res) => {
        dispatch(setActionItem("JOB_VIEW", "VIEW"))
        message.success(action?.msg);
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const qrCylinderSearchValidation = createLogic({
  type: QR_SEARCH_CYLINDER_VALIDATION,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    let payload = action.payload;
    payload.authToken = authToken
    dispatch(loaderFlag(true))

    Service({
      method: "post",
      url: API_ROUTES.QR_SEARCH_VALIDATION,
      data: payload,
    })
      .then((res) => {
        if (res?.data?.data) {
          if (res?.data?.data?.valid === false) {
            dispatch(setQRSearchCylinder(""))
            dispatch(setQrSearchCylinderValidation(false))
            dispatch(setQrResultData({}))
            dispatch(setPopUpMessageData({ modal: true, icons: [invalidScanner], message: ["invalidScanned"] }))
          } else {
            dispatch(setQrSearchCylinderValidation(true))
          }
        }
        dispatch(loaderFlag(false))
        done();
      })
      .catch((err) => {
        dispatch(loaderFlag(false))
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const getQRCylinderData = createLogic({
  type: GET_QR_CYLINDER_DATA,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    let payload = action.payload;
    payload.authToken = authToken
    dispatch(loaderFlag(true))
    Service({
      method: "post",
      url: API_ROUTES.GET_QR_SEARCH_CYLINDER,
      data: payload,
    })
      .then((res) => {
        dispatch(setQrSearchCylinderValidation(false))
        if (res?.data?.data) {
          dispatch(setQRSearchCylinder(res?.data?.data))
        } else {
          dispatch(setQRSearchCylinder(""))
        }
        dispatch(loaderFlag(false))
        done();
      })
      .catch((err) => {
        dispatch(loaderFlag(false))
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const updateFillRecoveryAwaitingData = createLogic({
  type: UPDATE_AWAITING_DATA,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    let payload = action.payload;
    payload.authToken = authToken
    Service({
      method: "post",
      url: API_ROUTES.UPDATE_JOBS,
      data: payload,
    })
      .then((res) => {
        if (res?.data?.data) {
          dispatch(setNotificationMessage({ type: "success", message: "JobUpdatedSuccessfully" }))
        }

      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const updateProcessCertificateReport = createLogic({
  type: UPDATE_PROCESS_CERTIFICATE,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    let payload = { authToken, ...action.payload?.payload };
    Service({
      method: "post",
      url: API_ROUTES.UPDATE_REPORT,
      data: payload,
    })
      .then((res) => {
        if (res?.data?.data) {
          dispatch(getSingleJobDetails({ jobId: action.payload?.payload?.jobId }));
          dispatch(setNotificationMessage({ type: "success", message: "reportUpdatedSuccessfully" }));
        }
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const searchUser = createLogic({
  type: SEARCH_USER,
  latest: true,
  process({ action }, dispatch, done) {
    dispatch(setApiLoader(true))
    const authToken = getItem("token");
    const userType = action.payload?.userType
    let payload = {
      businessName: action.payload?.businessName,
    };
    if (action.payload?.name) {
      payload.name = action.payload?.name
    }
    if (action.payload?.jobType) {
      payload.jobType = action.payload?.jobType
    }
    if (action.payload?.roleId) {
      payload.roleId = action.payload?.roleId
    }
    if (action.payload?.type) {
      payload.type = action.payload?.type
    }
    if (action.payload?.userId) {
      payload.userId = action.payload?.userId
    }
    if (action.payload?.forRoleId) {
      payload.forRoleId = action.payload?.forRoleId
    }
    if (action.payload?.source) {
      payload.source = action.payload?.source
    }
    payload.authToken = authToken
    Service({
      method: "post",
      url: API_ROUTES.SEARCH_USER_API(action.payload.pageNo),
      data: payload,
    })
      .then((res) => {
        if (res?.data?.data) {
          if (userType === "ASSOCIATE") {
            dispatch(setChildAssociateContractor({ type: "associate", data: res?.data?.data }))
          } else if (action.payload?.type === "NON_ASSOCIATE") {
            dispatch(setSearchNonAssociateUsers(res?.data?.data))
          } else {
            dispatch(setSearchUserData(res?.data?.data))
          }
        }
        dispatch(setApiLoader(false))
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false))
        done();
      });
  },
});

const searchUserBuilding = createLogic({
  type: BUILDING_USER_SEARCH,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    let payload = { authToken, ...action?.payload?.payload }
    Service({
      method: "post",
      url: API_ROUTES.SEARCH_USER_BUILDING(action?.payload?.pageNo),
      data: payload,
    })
      .then((res) => {
        if (res?.data?.data?.list.length) {
          dispatch(setSearchUserData(res?.data?.data))
        } else {
          dispatch(setSearchUserData(""))
        }
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const updateProcessJob = createLogic({
  type: UPDATE_PROCESS_JOB,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    let payload = action.payload;
    payload.authToken = authToken;
    Service({
      method: "post",
      url: API_ROUTES.UPDATE_PROCESS_JOBS,
      data: payload,
    })
      .then((res) => {
        if (res?.data?.data) {
          message.success(action?.msg)
          dispatch(cachingScannerData(action?.scannerData))
          dispatch(setActionItem("JOB_VIEW", "VIEW"))
        }
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const createJobIdLogic = createLogic({
  type: RECYCLE_JOB_CREATE,
  latest: true,
  process({ action }, dispatch, done) {
    Service({
      method: "POST",
      url: API_ROUTES.CREATE_JOB_API,
      data: action.payload,
    })
      .then((res) => {
        if (res.data.data.success === true) {
          dispatch(getJobId(res.data.data.jobId));
          dispatch(setNotificationMessage({ type: "success", message: "jobCreateSuccessfully" }));
        }
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const addReview = createLogic({
  type: ADD_REVIEW,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = action?.payload
    payload.authToken = authToken
    Service({
      method: "post",
      url: API_ROUTES.ADD_REVIEW_API,
      data: payload,
    })
      .then((res) => {
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const getReview = createLogic({
  type: GET_REVIEW,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = { authToken }
    payload.userId = action.payload.userId
    Service({
      method: "post",
      url: API_ROUTES.GET_REVIEW_API(action.payload.pageNo),
      data: payload,
    })
      .then((res) => {
        dispatch(setReviews(res?.data?.data?.list ? res?.data?.data?.list : []))
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const updateRefrigerantVolume = createLogic({
  type: UPDATE_REFRIGERANT_VOLUME,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    let payload = action.payload?.payload;
    const { updateCylinder = false, currentJobData = undefined, index = null } = action.payload
    payload.authToken = authToken;
    dispatch(apiLoader(true))
    Service({
      method: "patch",
      url: updateCylinder ? API_ROUTES.UPDATE_CYLINDERS : API_ROUTES.UPDATE_PROCESS_JOBS,
      data: payload,
    })
      .then((res) => {
        if (res?.data?.data) {
          if (updateCylinder) {
            let updatedData = JSON.parse(JSON.stringify(currentJobData))
            updatedData.recycleDisposeCylinderInfo[index] = res?.data?.data?.recycleDisposeCylinderInfo?.[0]
            dispatch(getUpdateApiData(updatedData));
          } else {
            dispatch(getUpdateApiData(res.data.data));
          }
          dispatch(setNotificationMessage({ type: "success", message: "JobUpdatedSuccessfully" }));
        }
        dispatch(apiLoader(false))
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(apiLoader(false))
        done();
      });
  },
});

const completeJob = createLogic({
  type: UPDATE_JOB_COMPLETE,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    let payload = action.payload?.payload;
    payload.authToken = authToken;
    Service({
      method: "post",
      url: API_ROUTES.UPDATE_PROCESS_JOBS,
      data: payload,
    })
      .then((res) => {
        if (res?.data?.data) {
          dispatch(setActionItem("JOB_VIEW", "VIEW"))
        }
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});
const searchMyJobLogic = createLogic({
  type: SEARCH_MY_JOBS,
  latest: true,
  process({ action, getState }, dispatch, done) {
    const authToken = getItem("token");
    const payload = { authToken, ...action?.payload?.payload };
    delete payload.cursor;
    delete payload.pageNo;
    const queryKey = JSON.stringify(Object.keys(payload).sort().map(key => [key, payload[key]]));
    const previous = getState().jobs.searchMyJobData || {};
    const requestedPage = action?.payload?.pageNo || 1;
    const sameQuery = previous.cursorQueryKey === queryKey;
    const pageCursors = sameQuery && requestedPage > 1 ? previous.pageCursors || {} : {};
    // Page numbers stay local; each subsequent request uses the saved API cursor.
    const cursor = requestedPage > 1 && sameQuery ? pageCursors[requestedPage] : undefined;
    const currentPage = cursor != null && cursor !== "" ? requestedPage : 1;
    if (currentPage > 1) {
      payload.cursor = cursor;
    }
    dispatch(loaderFlag(true));
    Service({
      method: "post",
      url: API_ROUTES.SEARCH_MY_JOBS,
      data: payload
    })
      .then((res) => {
        if (res?.data?.data) {
          const data = res.data.data;
          const hasMore = data.nextCursor != null && data.nextCursor !== "";
          dispatch(searchMyJobsData({
            ...data,
            hasMore,
            currentPage,
            cursorQueryKey: queryKey,
            pageCursors: {
              ...Object.fromEntries(Object.entries(pageCursors).filter(([page]) => Number(page) <= currentPage)),
              ...(hasMore ? { [currentPage + 1]: data.nextCursor } : {}),
            },
          }));
        } else {
          dispatch(searchMyJobsData({}))
        }
        dispatch(loaderFlag(false));
        done();
      })
      .catch((err) => {
        dispatch(loaderFlag(false))
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const shareCertificateLogic = createLogic({
  type: SHARE_CERTIFICATE,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    dispatch(loaderFlag(true))
    action.payload.authToken = authToken
    Service({
      method: "post",
      url: API_ROUTES.SHARE_API,
      data: { ...action?.payload },
    })
      .then((res) => {
        if (res?.data?.data) {
          dispatch(loaderFlag(false))
        }
      })
      .catch((err) => {
        dispatch(loaderFlag(false))
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const searchJobQrLogic = createLogic({
  type: SEARCH_QR_JOBS,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    dispatch(loaderFlag(true))
    const payload = { authToken, ...action?.payload?.payload }
    Service({
      method: "post",
      url: API_ROUTES.JOB_SEARCH_API,
      data: payload,
    })
      .then(async (res) => {
        if (res?.data?.data?.jobId) {
          dispatch(getSingleJobDetails({ jobId: res?.data?.data?.jobId }));
        } else {
          dispatch(setPopUpMessageData({ modal: true, icons: [invalidScanner], message: ["invalidScanned"] }))
        }
        dispatch(loaderFlag(false))
      })
      .catch((err) => {
        dispatch(loaderFlag(false))
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const jobRevertLogic = createLogic({
  type: JOB_REVERT,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    dispatch(loaderFlag(true))
    const payload = { authToken, ...action.payload?.payload };
    Service({
      method: "patch",
      url: API_ROUTES.REVERT_API,
      data: payload,
    })
      .then((res) => {
        dispatch(loaderFlag(false))
        if (res?.data?.data) {
          message.success(action.payload?.msg)
          dispatch(getJobId(""))
          if (action.payload?.revert) {
            dispatch(setQuickLinksData(action?.payload?.tabName?.jobTab))
            dispatch(jobDetail({ status: action?.payload?.tabName?.jobStatus, tab: action?.payload?.tabName?.jobTab }));
            dispatch(setActionItem("JOB_VIEW", "VIEW"));
          }
          dispatch(getActiveRentArrange({ pageNo: action.payload?.pageNo, payload: { status: action.payload?.tabName?.jobStatus, type: action.payload?.tabName?.jobTab } }));
        }
        done();
      })
      .catch((err) => {
        dispatch(loaderFlag(false))
        // dispatch(setNotificationMessage({ type: "error", message: "errMsg" }));
        done();
      });
  },
});

const updateConfirmationReport = createLogic({
  type: GET_CONFIRMATION_REPORT,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    Service({
      method: "GET",
      url: API_ROUTES.CONFIRMATION_REPORT(action?.payload?.jobId),
      header: { AUTH_TOKEN: authToken },
      data: { authToken }
    })
      .then((res) => {
        if (res?.data?.data) {
          dispatch(setConfirmationJobReport(res?.data?.data))
          // message.success(action?.msg)
        }
        done();
      })
      .catch((err) => {
        dispatch(setIntervalId({}))
        clearInterval(action?.payload?.intervalId)
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});
const updateHistoryLogic = createLogic({
  type: UPDATE_HISTORY,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    action.payload.authToken = authToken
    dispatch(setApiLoader(true))
    Service({
      method: "post",
      url: API_ROUTES.UPDATE_HISTORY(action?.pageNo),
      data: { ...action?.payload },
    })
      .then((res) => {
        if (res?.data?.data) {
          // message.success(action?.msg)
          dispatch(setUpdateHistory(res?.data?.data));
        }
        dispatch(setApiLoader(false))
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        dispatch(setApiLoader(false))
        done();
      });
  },
});

const fiscalYearLogic = createLogic({
  type: FISCAL_YEAR_LIST,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    Service({
      method: "get",
      url: API_ROUTES.FISCAL_YEAR,
      header: { AUTH_TOKEN: authToken },
      data: { authToken }
    })
      .then((res) => {
        if (res?.data?.data) {
          const fiscalYearList = res?.data?.data?.fiscalYear.reverse();
          dispatch(setFiscalYearList(fiscalYearList));
          // Set the first fiscal year as default if no fiscal year is set
          if (fiscalYearList && fiscalYearList.length > 0) {
            const currentFiscalYear = getItem("fiscalYear");
            if (!currentFiscalYear && fiscalYearList[0]?.year) {
              dispatch(setFiscalYear(fiscalYearList[0]?.year));
            }
          }
        }
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const updateRentReturnJob = createLogic({
  type: UPDATE_RENT_RETURN,
  latest: true,
  process({ action }, dispatch, done) {
    const authToken = getItem("token");
    const payload = { authToken, ...action.payload?.payload }
    Service({
      method: action.payload?.method,
      url: API_ROUTES.UPDATE_CYLINDER_JOB,
      data: payload,
    })
      .then((res) => {
        dispatch(getUpdateApiData(res?.data?.data))
        dispatch(setNotificationMessage({ type: "success", message: "JobUpdatedSuccessfully" }));
        done();
      })
      .catch((err) => {
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});



export default [
  searchMyJobLogic,
  getAllJobsLogic,
  updateJobLogic,
  AddJobEvidences,
  getJobEvidence,
  getAllRentArrange,
  createJobLogic,
  createRecoveryAndFillJobLogic,
  getSingleJobData,
  fillRecoveryJobCreateLogic,
  deleteCylinderLogic,
  // updateCylinderJobLogic,
  editRentalJobLogic,
  jobRevertLogic,
  addNewRecycleJob,
  addCompletedRecycleJob,
  qrCylinderSearchValidation,
  getQRCylinderData,
  updateFillRecoveryAwaitingData,
  updateProcessCertificateReport,
  searchUser,
  searchUserBuilding,
  updateProcessJob,
  addReview,
  getReview,
  createJobIdLogic,
  updateRefrigerantVolume,
  completeJob,
  shareCertificateLogic,
  updateHistoryLogic,
  setJobReadData,
  updateConfirmationReport,
  searchJobQrLogic,
  fiscalYearLogic,
  updateRentReturnJob
];
